export const genders = [
  {
    key: "male",
    label: "Male",
    value: "male",
  },
  {
    key: "female",
    label: "Female",
    value: "female",
  },
];